export const PROGRAM_TYPES = {
  GLOBAL_ENTRY: "GLOBAL_ENTRY",
  SENTRI: "SENTRI",
  NEXUS: "NEXUS",
};
